import { useNavigate, useParams } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
  Skeleton,
  toast,
} from "@/components/kit";
import { ProductFormPageHeader } from "@/modules/products/presentation/ui/ProductFormPageHeader";
import { useExpenseQuery, useUpdateExpense } from "../api/queries";
import { ExpenseForm } from "../ui/ExpenseForm";

export function ExpenseEditPage() {
  const { id } = useParams({ from: "/app/expenses/$id/edit" });
  const nav = useNavigate({ from: "/app/expenses/$id/edit" });
  const expense = useExpenseQuery(id);
  const update = useUpdateExpense(id);

  if (expense.isLoading) {
    return (
      <>
        <Header />
        <Main className="flex flex-col gap-4">
          <Skeleton className="h-10 w-56 rounded-lg" />
          <Skeleton className="h-96 w-full rounded-2xl" />
        </Main>
      </>
    );
  }

  if (!expense.data) {
    return (
      <>
        <Header />
        <Main>
          <div className="brand-card p-8">
            <Empty>
              <EmptyHeader>
                <EmptyTitle>ບໍ່ພົບລາຍຈ່າຍ</EmptyTitle>
                <EmptyDescription>
                  ລາຍຈ່າຍອາດຖືກລຶບ ຫຼື ID ບໍ່ຖືກຕ້ອງ
                </EmptyDescription>
              </EmptyHeader>
            </Empty>
          </div>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header />
      <Main>
        <ProductFormPageHeader
          title="ແກ້ໄຂລາຍຈ່າຍ"
          subtitle={expense.data.title}
          onBack={() => nav({ to: "/app/expenses" })}
        />

        <ExpenseForm
          key={expense.data.id}
          defaultValues={expense.data}
          submitting={update.isPending}
          submitLabel="ບັນທຶກການແກ້ໄຂ"
          onSubmit={async (values) => {
            try {
              await update.mutateAsync(values);
              toast.success("ອັບເດດລາຍຈ່າຍແລ້ວ");
              nav({ to: "/app/expenses" });
            } catch (e) {
              toast.error("ບັນທຶກລົ້ມເຫຼວ", {
                description: e instanceof Error ? e.message : undefined,
              });
            }
          }}
        />
      </Main>
    </>
  );
}
